module.exports = __webpack_public_path__ + "47be63762ef9126de11bbfc737209e3c.mp4";